import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import * as moment from "moment";
import { I18N } from "aurelia-i18n";

@autoinject
export class StregaSmartValveChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[1].data = [];
			this.chartData.datasets[2].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp).format("lll"));
				this.chartData.datasets[0].data.push(item.data.valveIsOpen === true ? 1 : 0);
				this.chartData.datasets[1].data.push(this.convertTemperature(item.data.temperature));
				this.chartData.datasets[2].data.push(item.data.hygrometery ? item.data.hygrometery.toFixed(2) : 0);
			});
			this.chart.refreshChart();
		}
	}

	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			datasets: [

				{
					label: "Valve",
						borderColor: "rgba(0,255,127,1)",
					pointColor: "rgba(0,255,127,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(0,255,127,1)",
					yAxisID: "Valve",
					data: []
				},
				{
					label: `Temperature (${this.getTemperatureSymbol()})`,
					fill: false,
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(0,0,255,1)",
					yAxisID: "Temperature",
					data: []
				},
				{
					label: `Hygrometery (%RH)`,
					fill: false,
					borderColor: "rgba(191, 0, 191, 1)",
					pointColor: "rgba(191, 0, 191, 1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(191, 0, 191, 1)",
					yAxisID: "Hygrometery",
					data: []
				}
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						}
					}
				],
				yAxes: [
					{
						id: "Valve",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Valve"
						},
						ticks: {
							min: -0.3,
							max: 1.3,
							fontSize: 16,
							fontStyle: 'bold',
							callback: value => {
								if (value === 0) {
									return "closed";
								} else {
									return value === 1 ? "open" : "";
								}
							}
						},
						position: "left"
					},
					{
						id: "Temperature",
						display: true,
						scaleLabel: {
							display: true,
							labelString: `Temperature  (${this.getTemperatureSymbol()})`
						},
						position: "right"
					},
					{
						id: "Hygrometery",
						display: true,
						scaleLabel: {
							display: true,
							labelString: `Hygrometery (%RH)`
						},
						position: "right"
					}
				]
			}
		};
	}
}
